// extracted by mini-css-extract-plugin
module.exports = {"bm-section":"bm-section","team-header":"team-header","bm-card":"bm-card","bm-card-image":"bm-card-image","bm-card-content":"bm-card-content","title":"title","subtitle":"subtitle"};